import { DateTime } from "luxon";

/** Patient names as duplicate detection compares them: trimmed, lowercase, whitespace collapsed. */
const normalizeName = (name: string | null | undefined) => (name ?? "").trim().toLowerCase().replace(/\s+/g, " ");

/** A missing or blank name never matches, not even another blank one. */
export const samePatientName = (a: string | null | undefined, b: string | null | undefined) => {
    const n = normalizeName(a);
    return n !== "" && n === normalizeName(b);
};

type When = { scheduledAt: string | null; createdAt: string };
const localDay = (v: When) => DateTime.fromISO(v.scheduledAt ?? v.createdAt, { zone: "local" });

export const sameLocalDay = (a: When, b: When) => localDay(a).hasSame(localDay(b), "day");
export const formatLocalDay = (v: When) => localDay(v).toFormat("MMM d");
